import ModernTable from "../shared/ModernTable";
import ScheduleDayListRow from "./ScheduleDayListRow";
import { ScheduleDocument } from "../../interfaces/ISchedules";
import { Box, Typography } from "@mui/material";
import { useMemo, useState } from "react";

interface ScheduleDaysTableProps {
  schedules: ScheduleDocument[];
  competitionName?: string;
  onRowClick: (schedule: ScheduleDocument) => void;
  onBack: () => void;
  emptyMessage?: string;
}

export default function ScheduleDaysTable({
  schedules,
  competitionName,
  onRowClick,
  onBack,
  emptyMessage = "Brak opublikowanego harmonogramu",
}: ScheduleDaysTableProps) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredSchedules = useMemo(() => {
    let list = [...schedules];
    list.sort((a, b) => a.day - b.day || a.dayLabel.localeCompare(b.dayLabel, "pl"));

    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase().trim();
      list = list.filter((schedule) => {
        const label = (schedule.dayLabel || "").toLowerCase();
        const dateRaw = schedule.date != null ? String(schedule.date).toLowerCase() : "";
        return (
          label.includes(term) ||
          String(schedule.day).includes(term) ||
          dateRaw.includes(term)
        );
      });
    }

    return list;
  }, [schedules, searchTerm]);

  const columns = [
    {
      id: "day",
      label: "Dzień harmonogramu",
      align: "left" as const,
    },
  ];

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="h6"
          component="h1"
          sx={{
            color: "primary.main",
            fontSize: { xs: "1rem", sm: "1.25rem" },
            fontWeight: 600,
          }}
        >
          Harmonogram
        </Typography>
        {competitionName ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {competitionName}
          </Typography>
        ) : null}
      </Box>
      <ModernTable
        data={filteredSchedules}
        columns={columns}
        searchPlaceholder="Wyszukaj dzień..."
        onSearch={setSearchTerm}
        searchValue={searchTerm}
        emptyMessage={searchTerm ? "Nie znaleziono dnia" : emptyMessage}
        showBackButton
        onBack={onBack}
        backButtonLabel="Wróć"
        renderRow={(schedule) => <ScheduleDayListRow schedule={schedule} />}
        onRowClick={(schedule) => onRowClick(schedule)}
        getItemKey={(schedule) => schedule.id}
      />
    </Box>
  );
}
